export default __webpack_public_path__ + "static/media/268.23a3605d.png";